<template>
  <form
    class="SignInForm"
    :class="{ 'invalid': hasSubmitted && !domainIsValid }"
    @submit.prevent="handleSubmit">
    <h4
      class="SignInForm_Title">
      {{ computedTitle }}
    </h4>

    <div
      class="SignInForm_Field">
      <input
        class="SignInForm_Field_Input"
        type="text"
        placeholder="example"
        v-model="domain.value"
        @keypress="preventSpace($event)"/>
      <h4
        class="SignInForm_Field_Suffix">
        .domo.com
      </h4>
    </div>

    <BaseButton
      class="mt-3"
      :block="blockButton"
      theme="orange"
      type="submit">
      CONTINUE
    </BaseButton>
  </form>
</template>

<script>
import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'SignInForm',

  components: {
    BaseButton,
  },

  data() {
    return {
      hasSubmitted: false,

      domain: {
        value: '',
        valid: false,
      },
    };
  },

  props: {
    blockButton: { type: Boolean, default: false },
  },

  computed: {
    domainIsValid() {
      return !!this.domain.value && !this.domain.value.match('@');
    },

    computedTitle() {
      if (this.hasSubmitted && !this.domain.value) return 'The domain field is required.';
      if (this.domain.value.match('@')) return 'Please use your Domo domain (not email address).';
      return 'Enter your Domo domain to sign in.';
    },
  },

  methods: {
    preventSpace(e) {
      if (e.which === 32) e.preventDefault();
    },

    handleSubmit() {
      this.hasSubmitted = true;
      if (!this.domainIsValid) return;
      const rootIncluded = this.domain.value.match('(.*).domo.com');
      window.location.href = `https://${this.domain.value}${rootIncluded ? '' : '.domo.com'}/auth/index`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.SignInForm {
  text-align: center;
}

.SignInForm_Title {
  font-size: 16px;
}

.SignInForm.invalid .SignInForm_Title {
  color: #E55;
}

.SignInForm_Field {
  position: relative;
  margin-top: 24px;
  text-align: left;
  border-radius: 3px;
  background-color: #555555;
}

.SignInForm_Field_Input {
  display: block;
  width: 50%;
  height: 40px;
  padding-right: 14px;
  text-align: right;
  font-size: 16px;
  border: none;
  border-radius: 3px 0 0 3px;
}

.SignInForm_Field_Suffix {
  position: absolute;
  top: 0;
  left: 50%;
  padding-left: 14px;
  color: #888888;
  line-height: 40px;
  font-size: 16px;
}
</style>
